import {booking} from "./feature.booking.svelte.js";
import * as money_util from "../../utils/MoneyUtil.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as booking_select_export from "./booking.scenarios.select.export.svelte.js";
import AppConfig from "../../AppConfig.js";

export function getBookingExportJSON()
{
  const oBooking = booking_select_export.getBookingExport(true);
  return JSON.stringify(oBooking);
}

// Dit is wat in JSON gewrapped als booking json mee gaat naar de server bij booking en availability - dit is NIET de summary voor de bon, dat is booking_select.getBookingSummary
export function getBookingExport(bAddRelevantHiddenProducts = false)
{
  const oBooking = {
    sDate: booking.sArrivalDate,
    sStartTime: booking.iArrivalTime,
    sEndTime: booking.iDepartureTime,
    aPeople: booking.lPeople.map((oPersonInStore) => {
      const oPerson = {
        // backend benaming - NB de inhoud en structuur van deze 3 parameters niet zomaar aanpassen - backend vertrouwt op deze structuur
        arrangements: oPersonInStore.lBookedPackageDeals.map((deal) => deal.iID),
        productsWithoutArr: booking_select.getAllBookedProductsThatAreNotPartOfAnyPackageDealWithTimeSlots(oPersonInStore.sID, true, true),
        productsPartOfArr: [],
        allProducts: booking_select.getAllBookedProductsThatAreNotPartOfAnyPackageDealWithTimeSlots(oPersonInStore.sID, true, true)  // backend benaming - daar wordt er vanuit gegaan dat product ids die hier in staan maar niet in productsWithoutArr dus bij het arrangement horen
      };

      // Is er een arrangement?
      for ( const oPackageDeal of oPersonInStore.lBookedPackageDeals )
      {
        let aBookedProductsInPackageDeal = booking_select.getAllBookedProductIDsForPackageDealIDWithTimeSlot(oPersonInStore, oPackageDeal.iID);
        oPerson.allProducts = oPerson.allProducts.concat(aBookedProductsInPackageDeal);
        oPerson.productsPartOfArr.concat(aBookedProductsInPackageDeal);
      }

      // Restaurant
      const bAddDinner = booking.bWantsDinner;
      if ( bAddRelevantHiddenProducts === true && bAddDinner === true )
      {
        let oDinnerConfig = {
          iID: AppConfig.iDinnerProductID
        }

        if ( booking.sPreferredDinnerTime )
        {
          oDinnerConfig.sTime = booking.sPreferredDinnerTime;
        }

        oPerson.productsWithoutArr.push(oDinnerConfig);
        oPerson.allProducts.push(oDinnerConfig);
        oPerson.sID = oPersonInStore.sID;
      }

      return oPerson;
    })
    //oTotals: booking.mTotals
  };

  oBooking.lValidBadenkaartCodes = booking.lValidBadenkaartCodes; // dit bestaat niet meer

  let iBadenkaartTotalsCents = 0;
  const aValidBadenkaartCodes = booking.lValidBadenkaartCodes;

  aValidBadenkaartCodes.forEach((oBadenkaart, index) => {
    const iBadenkaartValueCents = oBadenkaart.iValueCents;
    iBadenkaartTotalsCents += iBadenkaartValueCents;
  });

  let oBadenkaartTotalsFriendly = money_util.centsToFriendly(iBadenkaartTotalsCents);

  let sTotalBookingEuros = parseInt(booking.mTotals.mTotal.mFriendly.sEuros) + parseInt(oBadenkaartTotalsFriendly.sEuros);
  let sTotalBookingCents = parseInt(booking.mTotals.mTotal.mFriendly.sCents) + parseInt(oBadenkaartTotalsFriendly.sCents);

  oBooking.oTotals = {
    nTotal: booking.mTotals.mTotal.iCents + iBadenkaartTotalsCents,
    sTotal: sTotalBookingEuros + ',' + money_util.centsToFriendly(sTotalBookingCents).sCents
  };

  oBooking.aValidRedeemCodes = booking.aValidRedeemCodes;
  oBooking.iPreselectedActionEntryProductID = booking.iPreselectedActionEntryProductID;

  oBooking.lValidBadenkaartCodes = booking.lValidBadenkaartCodes;
  return oBooking;
}

